import { Navigate } from 'react-router-dom'
import { ScreeningQuestionnaire } from '../../../components/screening/ScreeningQuestionnaire'
import { useSelectCertificationScreeningId } from '../../../state/selectors'
import { ROUTES } from '../../../constants/routes'

export const CertificationQuestions = () => {
  const certificationScreeningId = useSelectCertificationScreeningId()

  if (!certificationScreeningId) return <Navigate to={ROUTES.ADMIN_CERTIFICATION} replace />

  return (
    <ScreeningQuestionnaire
      screeningId={certificationScreeningId}
      submitPath={ROUTES.ADMIN_CERTIFICATION_UPLOAD}
      closePath={ROUTES.ADMIN_CERTIFICATION}
    />
  )
}
